<template>
  <v-chip
    class="font-weight-bold fullfillment-status-label"
    :class="fulfillmentStatusLabelClass"
    :small="$vuetify.breakpoint.xsOnly"
    :color="color"
    v-text="$itemFulfillmentMixin_fulfillmentStatusLabelMap[fulfillmentStatus]"
  />
</template>

<script>
import { ItemFulfillmentMixin } from '../shared/mixins/item-fulfillment-mixin'

export default {
  name: 'ItemControlFulfillmentStatus',
  mixins: [ItemFulfillmentMixin],
  props: {
    fulfillmentStatus: {
      required: true,
      type: String
    }
  },
  computed: {
    fulfillmentStatusLabelClass () {
      return this.fulfillmentStatus
        ? `fullfillment-status-label-${this.fulfillmentStatus.toLocaleLowerCase()}`
        : ''
    },
    color () {
      return this.$itemFulfillmentMixin_fulfillmentStatusColorMap[
        this.fulfillmentStatus
      ]
    }
  }
}
</script>
